import { api } from "@/services";
import { BannersResponse } from "@/types";
import { useIsomorphicLayoutEffect } from "framer-motion";
import qs from "qs";
import { useState } from "react";

function useBannersContents(): [Response: BannersResponse, Error: string | null, Loading: boolean] {
  const [Response, setResponse] = useState<BannersResponse>(null as BannersResponse);
  const [Error, setError] = useState<string>(null);
  const [Loading, setLoading] = useState<boolean>(true);

  useIsomorphicLayoutEffect(() => {
    const Controller = new AbortController();

    const MakeRequest = async () => {
      try {
        const resp: { data: BannersResponse } = await api.get(`Contents/GetBySlug`, {
          signal: Controller.signal,
          params: {
            slugs: ["banners-linglong"]
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, {
              arrayFormat: "repeat"
            });
          }
        });
        if (resp.data) {
          setResponse(resp.data);
        } else {
          setError("Nenhum conteúdo encontrado");
        }
      } catch (Err) {
        setError(Err.message);
      } finally {
        setLoading(false);
      }
    };

    MakeRequest();

    return () => Controller.abort();
  }, []);

  return [Response, Error, Loading];
}

export { useBannersContents };
